let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iq6Zv")).then(() => parcelRequire('8pP5E'));